export const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/igyZgFTdjir2Wk79uJGxiP/Mockup_LB.png'
